import { render, staticRenderFns } from "./CheckSystemUpdate.vue?vue&type=template&id=f67a5c56"
import script from "./CheckSystemUpdate.vue?vue&type=script&lang=js"
export * from "./CheckSystemUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports